import ENCTags from "./ENCTags";
import EMITags from "./EMITags";
import ADQTags from "./ADQTags";
import TOTTags from "./TOTTags";
import DRFTags from "./DRFTags";
import MEPTags from "./MEPTags";
import ITETags from "./ITETags";
import RFDTags from "./RFDTags";
import CSLTags from "./CSLTags";
import NOTTags from "./NOTTags";
import REFTags from "./REFTags";
import ANTTags from "./ANTTags";
import ANTTags2 from "./ANTTags2";

const BuildXMLHealth = (data, typeDocumentInvoice) => {
    
    let clinica = JSON.parse(sessionStorage.getItem('clinica'));
    clinica.localidad = JSON.parse(sessionStorage.getItem('localidad'));
    var doc = document.implementation.createDocument("", "", null);

    //Documento XML
    var facturaXML = null;
    let nameElement = typeDocumentInvoice == "INVOICE" ? "FACTURA" : "NOTA";

    facturaXML = doc.createElement(nameElement);
    facturaXML.setAttribute("version", "1.0");
    facturaXML.setAttribute("encoding", "UTF-8");
    facturaXML.setAttribute("standalone", "no");

    const recibosCajaOrdenados = [... data.recibosCaja].sort((a, b) => new Date(a.fecha_admision) - new Date(b.fecha_admision));
    const fechaMenorRecibo = recibosCajaOrdenados[0].fecha_admision;

    //Etiquetas Comerciales
    facturaXML.appendChild(ENCTags(doc, data, clinica, typeDocumentInvoice, fechaMenorRecibo  ));//Encabezado de la Factura }) 
    facturaXML.appendChild(EMITags(doc, data, clinica, typeDocumentInvoice));//Registros Tributarios
    facturaXML.appendChild(ADQTags(doc, data, clinica));//Registros del Adquiriente
    if (!!data.totalCopagos) {
        let receiptsWithoutTotalInZero = data.recibosCaja.filter((receipt)=> parseInt(receipt.total) !== 0);
		
		if(receiptsWithoutTotalInZero.length <= 4){
			receiptsWithoutTotalInZero.map((item, index) => facturaXML.appendChild(ANTTags(doc, data, item, index)));
		}else{
			facturaXML.appendChild(ANTTags2(doc, data));
		}
    }
    facturaXML.appendChild(TOTTags(doc, data, clinica, typeDocumentInvoice));//Totales de la Factura 
    facturaXML.appendChild(DRFTags(doc, data, clinica, typeDocumentInvoice));//Detalles de Facturación Electronica
    facturaXML.appendChild(NOTTags(doc, data, clinica, null, null, "NOTA"));
    //data.recibosCaja.map((item, index) => facturaXML.appendChild(NOTTags(doc, data, clinica, item, index, "SALUD")));//Items de la Factura
    facturaXML.appendChild(MEPTags(doc, data, clinica));//Detalles del Pago
    data.items.map((item, index) => facturaXML.appendChild(ITETags(doc, data, clinica, item, index)));//Items de la Factura

    //Etiquetas de Factura en Salud
    if (data.totalCopagosReal > 0) {
        facturaXML.appendChild(RFDTags(doc, data, clinica, 1));//Copago Confirmado
    }

    if (data.totalCuotaModeradora > 0) {
        facturaXML.appendChild(RFDTags(doc, data, clinica, 2));
    }

    if (data.totalPagosCompartidosVoluntariosEnSalud > 0) {
        facturaXML.appendChild(RFDTags(doc, data, clinica, 3));
    }

    facturaXML.appendChild(CSLTags(doc, data, clinica));

    if (nameElement == "NOTA") {
        facturaXML.appendChild(REFTags(doc, data, clinica));//Detallacion de Referencia para la Nota Credito
    }

    doc.appendChild(facturaXML);
        
    return doc;
}

export default BuildXMLHealth;